"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sum = void 0;
var React = require("react");
function sum(Table, precision) {
    if (precision === void 0) { precision = 2; }
    return /** @class */ (function (_super) {
        __extends(SumTable, _super);
        //无状态
        function SumTable(props) {
            var _this = _super.call(this, props) || this;
            _this.getNodeItem = function (array, newArray) {
                array.forEach(function (da, i) {
                    if (da.children) {
                        _this.getNodeItem(da.children, newArray);
                    }
                    else {
                        newArray.push(da);
                    }
                });
            };
            /**
             * 获取当前的表格类型。
             *
             */
            _this.getTableType = function () {
                var columns = _this.props.columns;
                var type = "array";
                columns.find(function (da, i) {
                    if (da.children) {
                        type = "tree";
                        return type;
                    }
                });
                return type;
            };
            _this.addSumData = function () {
                var _a = _this.props, _b = _a.data, data = _b === void 0 ? [] : _b, _c = _a.columns, columns = _c === void 0 ? [] : _c;
                if ((data === null || data === void 0 ? void 0 : data.length) === 0) {
                    // 无数据时不返回合计行
                    return data;
                }
                var sumdata = {}, newColumns = [], newData = [];
                if (!Array.isArray(columns)) {
                    console.log("columns type is error !");
                    return;
                }
                var type = _this.getTableType();
                if (type == "tree") {
                    _this.getNodeItem(columns, newColumns);
                }
                else {
                    newColumns = columns;
                }
                //返回一个新的数据
                newData = data.slice();
                newColumns.forEach(function (column, index) {
                    sumdata[column.dataIndex] = "";
                    if (column.sumCol) {
                        var count_1 = 0;
                        data.forEach(function (da, i) {
                            var _num = parseFloat(da[column.key]);
                            //排查字段值为NAN情况
                            if (_num == _num) {
                                count_1 += _num;
                            }
                        });
                        var sum_1 = count_1;
                        // @ts-ignore
                        sumdata[column.dataIndex] = sum_1;
                        if (column.sumRender && typeof column.sumRender == "function") {
                            // @ts-ignore
                            sumdata[column.dataIndex] = column.sumRender(sum_1);
                        }
                    }
                    if (index == 0) {
                        // @ts-ignore
                        sumdata[column.dataIndex] = "合计 " + sumdata[column.dataIndex];
                    }
                });
                newData.push(sumdata);
                return newData;
            };
            //array , tree
            // @ts-ignore
            _this.tableType = "array";
            return _this;
        }
        SumTable.prototype.toThousands = function (num) {
            var result = "", counter = 0;
            num = (num || 0).toString();
            var numArr = num.split(".");
            num = numArr[0];
            for (var i = num.length - 1; i >= 0; i--) {
                counter++;
                result = num.charAt(i) + result;
                if (!(counter % 3) && i != 0) {
                    result = "," + result;
                }
            }
            return numArr.length === 1 ? result : result + "." + numArr[1];
        };
        SumTable.prototype.render = function () {
            return (React.createElement(Table, __assign({}, this.props, { columns: this.props.columns, showSum: true, data: this.addSumData() })));
        };
        return SumTable;
    }(React.PureComponent));
}
exports.sum = sum;
